import VueCoreImageUpload from './vue-core-image-upload.vue';
export default VueCoreImageUpload;



//////////////////
// WEBPACK FOOTER
// ./~/vue-core-image-upload/dist/index.js
// module id = 283
// module chunks = 0